import React from 'react';
import CanvasWrapper from './components/CanvasWrapper';
import GalaxyField from './components/particles/GalaxyField';

const SplineScene: React.FC = () => (
    <CanvasWrapper>
        <GalaxyField count={8000} />
    </CanvasWrapper>
);

export default SplineScene;